import { render, staticRenderFns } from "./ticket-history.vue?vue&type=template&id=66237d20"
import script from "./ticket-history.vue?vue&type=script&lang=js"
export * from "./ticket-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports